import { Card, Col, Row, Typography } from "antd";
import { CompanyLogo } from "@bindeleddet/core/components";
import { message } from "@bindeleddet/core/utils";
import { Event } from "@bindeleddet/core/types";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import dayjs from "dayjs";
import { toCapitalCase } from "helpers/strings";
import React from "react";
import { useHistory } from "react-router-dom";
import EventStatusBadge from "../../EventCard/EventStatusBadge/EventStatusBadge";

const { Text } = Typography;

interface Props {
  event: Event;
}

const EventCardMobile: React.FC<Props> = ({ event }) => {
  const { currentUser } = useLoginContext();
  const history = useHistory();

  // Open event details
  const openEvent = () => {
    if (!currentUser) {
      return message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    }
    if (isCompanyUser(currentUser) && event.company.id !== currentUser.id) {
      return message("error", "Bedrifter kan kun åpne egne arrangementer");
    }
    return history.push(`/events/${event.id}/`);
  };

  return (
    <Card hoverable onClick={openEvent} bodyStyle={{ padding: "10px" }}>
      <Row align="middle">
        <Col span={6}>
          <CompanyLogo key={event.company.id} src={event.company.logo} companyId={event.company.id} size="50px" />
        </Col>
        <Col span={13}>
          <Text strong>
            {toCapitalCase(dayjs(event.start).format("dddd"))} {dayjs(event.start).format("D. MMMM")}
          </Text>
        </Col>
        <Col span={5}>
          <EventStatusBadge status={event.registration_status} />
        </Col>
      </Row>
    </Card>
  );
};

export default EventCardMobile;
